export default __webpack_public_path__ + "static/media/EFICIENCIA_ICON.c9dc2c09.svg";